import { jsx as t } from "react/jsx-runtime";
const r = ({ size: o = 24, className: e }) => /* @__PURE__ */ t(
  "svg",
  {
    className: e,
    width: o,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M21 17.25H9M9 17.25C9 15.5931 7.65685 14.25 6 14.25C4.34315 14.25 3 15.5931 3 17.25C3 18.9069 4.34315 20.25 6 20.25C7.65685 20.25 9 18.9069 9 17.25ZM3 6.75L15 6.75M15 6.75C15 8.40685 16.3431 9.75 18 9.75C19.6569 9.75 21 8.40686 21 6.75C21 5.09315 19.6569 3.75 18 3.75C16.3431 3.75 15 5.09315 15 6.75Z",
        stroke: "#023D3D",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  r as ToggleIcon
};
